// Gatsby entry for consent-gated GA4. Only the public build-time ID is read; there is no test
// override here and loopback hosts never measure. Logic and limits live in analytics-core.cjs.
import { getPreference, setPreference } from './preferences';
import { createAnalytics, CONSENT_KEY } from './analytics-core.cjs';
import { SCHEMA_VERSION, buckets } from './analytics-events.cjs';

const analytics = createAnalytics({
  measurementId: process.env.GATSBY_GA_MEASUREMENT_ID || '',
  storage: { get: getPreference, set: setPreference },
  debug: process.env.NODE_ENV !== 'production',
});
export const analyticsConfigured = analytics.configured;
export const consentKey = CONSENT_KEY;
export const EVENT_SCHEMA_VERSION = SCHEMA_VERSION;
export { buckets };
// Status: { profile:'on'|'off', reason, loopback, consent, bannerRequired, trackingActive, track }.
export const analyticsProfile = () => analytics.analyticsProfile();
export const isLocalEnvironment = () => analytics.isLocalEnvironment();
export const consentState = () => analytics.consentState();
export const subscribeConsent = listener => analytics.subscribeConsent(listener);
export const setConsent = accepted => analytics.setConsent(accepted);
// track(name, params) → { sent, reason, params?, errors? }; no-op unless profile ON + consent + non-loopback.
export const track = (name, params) => analytics.track(name, params);
export const trackOnce = (key, name, params) => analytics.trackOnce(key, name, params);
export const trackSettled = (key, name, params, delay) => analytics.trackSettled(key, name, params, delay);
export const cancelSettled = key => analytics.cancelSettled(key);
export const setPageContext = values => analytics.setPageContext(values);
export const handleRouteUpdate = (location, prevLocation) => analytics.handleRouteUpdate(location, prevLocation);
export const installLinkTracking = target => analytics.installLinkTracking(target);
